import React from 'react';
import { DashboardCard } from './DashboardCard';
import { DollarSignIcon, PencilRulerIcon, PackageIcon, LineChartIcon, BarChart3Icon, ArrowUpDownIcon, FilterIcon, ArrowRightIcon, TrendingUpIcon } from 'lucide-react';
export function QuotesOverview() {
  // Mock data
  const quotesData = {
    total: 2392,
    pivots: 3716,
    spareParts: 0,
    linears: 0,
    conversionRate: '0%'
  };
  const regions = [{
    name: 'Aisco MENA',
    value: 6,
    max: 1600,
    percentage: 0.4
  }, {
    name: 'Aisco AFRICA',
    value: 12,
    max: 1600,
    percentage: 0.8
  }, {
    name: 'Aisco EUROPE',
    value: 650,
    max: 1600,
    percentage: 40.6
  }, {
    name: 'Aisco AMERICA',
    value: 1590,
    max: 1600,
    percentage: 99.4
  }, {
    name: 'Aisco ANZ',
    value: 94,
    max: 1600,
    percentage: 5.9
  }];
  const dealers = [{
    name: 'TEXAS INTERNATIONAL IRRIGATION',
    count: 167
  }, {
    name: 'UWR',
    count: 113
  }, {
    name: 'I-BEAM Irrigation',
    count: 111
  }, {
    name: 'AQUADOC',
    count: 97
  }, {
    name: 'NORTHERN IRRIGATION SYSTEMS',
    count: 92
  }, {
    name: 'CAN AGRO LLP',
    count: 90
  }, {
    name: 'VK SALES & SERVICE',
    count: 81
  }, {
    name: 'IMPER REGAS Lda',
    count: 74
  }];
  return <div className="space-y-6" data-id="element-1703">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1704">
        <DashboardCard icon={<DollarSignIcon size={20} className="text-blue-400" data-id="element-1706" />} title="Total Quotes" className="md:col-span-2" data-id="element-1705">
          <div className="flex flex-col" data-id="element-1707">
            <div className="text-5xl font-bold text-white mb-6" data-id="element-1708">
              {quotesData.total}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-1709">
              <QuoteTypeCard icon={<PencilRulerIcon size={18} data-id="element-1711" />} label="Pivots" value={quotesData.pivots} data-id="element-1710" />
              <QuoteTypeCard icon={<PackageIcon size={18} data-id="element-1713" />} label="Spare parts" value={quotesData.spareParts} data-id="element-1712" />
              <QuoteTypeCard icon={<LineChartIcon size={18} data-id="element-1715" />} label="Linears" value={quotesData.linears} data-id="element-1714" />
            </div>
            <div className="h-40 relative" data-id="element-1716">
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between px-2" data-id="element-1717">
                {Array.from({
                length: 12
              }, (_, i) => <div key={i} className="flex flex-col items-center" data-id="element-1718">
                      <div className="w-8 bg-blue-500 rounded-t-sm" style={{
                  height: `${Math.random() * 100 + 20}px`
                }} data-id="element-1719"></div>
                      <div className="text-xs text-blue-300 mt-1" data-id="element-1720">
                        {new Date(0, i).toLocaleString('default', {
                    month: 'short'
                  })}
                      </div>
                    </div>)}
              </div>
            </div>
          </div>
        </DashboardCard>
        <DashboardCard icon={<TrendingUpIcon size={20} className="text-blue-400" data-id="element-1722" />} title="Conversion Rate" data-id="element-1721">
          <div className="flex flex-col items-center justify-center h-full" data-id="element-1723">
            <div className="relative w-40 h-40 mb-4" data-id="element-1724">
              <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-1725">
                <circle cx="50" cy="50" r="40" fill="transparent" stroke="#1e40af" strokeWidth="15" data-id="element-1726" />
                <circle cx="50" cy="50" r="40" fill="transparent" stroke="#3b82f6" strokeWidth="15" strokeDasharray="251.2" strokeDashoffset="251.2" transform="rotate(-90 50 50)" data-id="element-1727">
                  <animate attributeName="stroke-dashoffset" from="251.2" to="251.2" dur="1s" fill="freeze" data-id="element-1728" />
                </circle>
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-1729">
                <div className="text-3xl font-bold text-white" data-id="element-1730">
                  {quotesData.conversionRate}
                </div>
                <div className="text-sm text-blue-300" data-id="element-1731">Conversion</div>
              </div>
            </div>
            <div className="text-center" data-id="element-1732">
              <div className="text-sm text-blue-300 mb-2" data-id="element-1733">
                Opportunities for improvement
              </div>
              <button className="inline-flex items-center px-3 py-1.5 rounded-lg bg-blue-500/20 text-blue-300 hover:bg-blue-500/30 transition-colors text-sm" data-id="element-1734">
                View Analysis
                <ArrowRightIcon size={14} className="ml-1" data-id="element-1735" />
              </button>
            </div>
          </div>
        </DashboardCard>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1736">
        <DashboardCard icon={<BarChart3Icon size={20} className="text-blue-400" data-id="element-1738" />} title="Regional Distribution" className="md:col-span-3" data-id="element-1737">
          <div className="space-y-4" data-id="element-1739">
            {regions.map(region => <div key={region.name} className="space-y-2" data-id="element-1740">
                <div className="flex justify-between" data-id="element-1741">
                  <span className="text-sm text-blue-300" data-id="element-1742">{region.name}</span>
                  <span className="text-sm font-medium text-white" data-id="element-1743">
                    {region.value} quotes
                  </span>
                </div>
                <div className="w-full bg-slate-700/50 rounded-full h-2.5 overflow-hidden" data-id="element-1744">
                  <div className="bg-blue-500 h-2.5 rounded-full" style={{
                width: `${region.percentage}%`
              }} data-id="element-1745"></div>
                </div>
                <div className="flex justify-between text-xs text-slate-400" data-id="element-1746">
                  <span data-id="element-1747">0</span>
                  <span data-id="element-1748">{region.max}</span>
                </div>
              </div>)}
          </div>
        </DashboardCard>
      </div>
      <DashboardCard icon={<BarChart3Icon size={20} className="text-blue-400" data-id="element-1750" />} title="Quotes by Dealers" footer={<div className="flex justify-between text-sm text-blue-300" data-id="element-1751">
            <span data-id="element-1752">Showing 8 of 32 dealers</span>
            <button className="text-blue-400 hover:text-white" data-id="element-1753">View All</button>
          </div>} data-id="element-1749">
        <div className="flex justify-end mb-4" data-id="element-1754">
          <div className="flex items-center space-x-2" data-id="element-1755">
            <button className="p-2 rounded-lg bg-slate-800 text-blue-300 hover:bg-slate-700 transition-colors" data-id="element-1756">
              <ArrowUpDownIcon size={16} data-id="element-1757" />
            </button>
            <button className="p-2 rounded-lg bg-slate-800 text-blue-300 hover:bg-slate-700 transition-colors" data-id="element-1758">
              <FilterIcon size={16} data-id="element-1759" />
            </button>
          </div>
        </div>
        <div className="space-y-4" data-id="element-1760">
          {dealers.map((dealer, index) => <div key={index} className="flex items-center" data-id="element-1761">
              <div className="flex-1 text-white" data-id="element-1762">{dealer.name}</div>
              <div className="w-1/2" data-id="element-1763">
                <div className="flex items-center" data-id="element-1764">
                  <div className="flex-1 mr-4" data-id="element-1765">
                    <div className="w-full bg-slate-700/50 rounded-full h-2.5" data-id="element-1766">
                      <div className="bg-blue-500 h-2.5 rounded-full" style={{
                    width: `${dealer.count / 167 * 100}%`
                  }} data-id="element-1767"></div>
                    </div>
                  </div>
                  <div className="text-blue-300 text-sm w-10 text-right" data-id="element-1768">
                    {dealer.count}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </DashboardCard>
    </div>;
}
function QuoteTypeCard({
  icon,
  label,
  value
}) {
  return <div className="bg-slate-800/50 rounded-lg p-4" data-id="element-1769">
      <div className="flex justify-between items-center mb-2" data-id="element-1770">
        <div className="flex items-center" data-id="element-1771">
          <div className="p-2 rounded-lg bg-slate-700/50 mr-3" data-id="element-1772">
            <span className="text-blue-300" data-id="element-1773">{icon}</span>
          </div>
          <div className="text-sm text-blue-300" data-id="element-1774">{label}</div>
        </div>
        <div className="text-xl font-bold text-white" data-id="element-1775">{value}</div>
      </div>
    </div>;
}